import React, { useState } from 'react'
import dotPropImmutable from 'dot-prop-immutable'
import ChordParser from '../../utils/ChordParser'
import classNames from 'classnames'
import { useChartEditContext } from './edit/ChartEditContext'

interface Props {
  beat: string
  beat_i: number
  path: string
  edit_location: string | null
  onEditInputFocus: (e: React.FocusEvent<HTMLInputElement>) => void
}

export default function BeatInput({ beat, beat_i, path, edit_location, onEditInputFocus }: Props) {
  const [parsedChord, setParsedChord] = useState<ChordParser | null>(null)

  const { setEditedChart } = useChartEditContext();

  const beatInputClasses = (beat: string) => {
    const classes = []
    if (beat === '-') classes.push('dark')
    if (dotPropImmutable.get(parsedChord, 'parsed.type') === 'not_recognized') classes.push('not_recognized')
    return classes.join(' ')
  }

  const inputClasses = classNames(
    'text-sm',
    'bg-transparent',
    'border',
    'border-gray-600',
    'rounded',
    'px-1',
    'w-full',
    'beat',
    'dark',
    edit_location === path ? 'active' : '',
    beatInputClasses(beat)
  )

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setParsedChord(new ChordParser(e.target.value))
    setEditedChart(draft => dotPropImmutable.set(draft, path, e.target.value))
  }

  return (
    <span className="beat-input-component">
      <input
        name={path}
        type="text"
        className={inputClasses}
        onChange={onChange}
        value={beat}
        onFocus={onEditInputFocus}
      />
    </span>
  )
}
